// One focus/scroll contract for skip links and both kinds of page jump list.
export function readingTarget(target) {
    if (target.matches('h1, h2, h3, h4, h5, h6')) return target;
    return target.querySelector('h1, h2, h3, h4, h5, h6') || target;
}

export function focusTarget(target) {
    const addedTabIndex = !target.hasAttribute('tabindex');
    if (addedTabIndex) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
    if (addedTabIndex) target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
}

export function headerOffset(target) {
    let height = 16;
    const header = document.querySelector('.site-header');
    const bar = document.getElementById('wpadminbar');
    for (const element of [header, bar]) {
        if (!element || !['sticky', 'fixed'].includes(getComputedStyle(element).position)) continue;
        height += element.getBoundingClientRect().height;
    }
    document.querySelectorAll('.sticky-offset-header').forEach(element => {
        if (element.contains(target) || !(element.compareDocumentPosition(target) & Node.DOCUMENT_POSITION_FOLLOWING)) return;
        if (['sticky', 'fixed'].includes(getComputedStyle(element).position)) height += element.getBoundingClientRect().height;
    });
    return height;
}

export function jumpTo(target, { hash, keyboard = true } = {}) {
    document.dispatchEvent(new CustomEvent('coto:reveal-section', { detail: { target } }));
    let details = target.closest('details');
    while (details) { details.open = true; details = details.parentElement?.closest('details'); }
    const destination = readingTarget(target);
    focusTarget(destination);
    if (hash && window.location.hash !== hash) window.history.pushState(null, '', hash);
    window.scrollTo({
        top: Math.max(0, destination.getBoundingClientRect().top + window.scrollY - headerOffset(destination)),
        behavior: keyboard || window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
    return destination;
}

export function unmodifiedActivation(event) {
    return event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
}

export function hashTarget(hash) {
    try { return document.getElementById(decodeURIComponent(hash.slice(1))); } catch { return null; }
}
